import { ScheduleList } from './views';

export default {
  list: ScheduleList,
  name: 'schedule',
  label: 'Schedule',
  to: '/schedule',
};
